import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { VendorsRouteNames } from '../../enums/router-names';
import { VendorsRoutePathNames } from '../../enums/url-paths';

const Update = () => import('./Update.vue');

export const updateRoute: RouteRecordRaw = {
  path: buildChildURL(VendorsRoutePathNames.UPDATE),
  name: VendorsRouteNames.VENDORS_UPDATE,
  component: Update,
};
